{
  "location_not_available": "Location not available",
  "map": {
    "title": "Map",
    "navigation_title": "Map"
  }
}
